/**
 * @generated SignedSource<<b855e7cfb92c07f45062c301b89c496d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PointsAdditionsTable_QueryFragment$data = {
  readonly Admin: {
    readonly PointsV2: {
      readonly GetFilteredPointsAdditions: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly id: string;
            readonly " $fragmentSpreads": FragmentRefs<"PointsAdditionsTable_PointsAdditionFragment">;
          };
        } | null | undefined> | null | undefined;
        readonly pageInfo: {
          readonly endCursor: string | null | undefined;
          readonly hasNextPage: boolean;
          readonly hasPreviousPage: boolean;
          readonly startCursor: string | null | undefined;
        };
      };
    };
  };
  readonly " $fragmentType": "PointsAdditionsTable_QueryFragment";
};
export type PointsAdditionsTable_QueryFragment$key = {
  readonly " $data"?: PointsAdditionsTable_QueryFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"PointsAdditionsTable_QueryFragment">;
};

const node: ReaderFragment = (function(){
var v0 = [
  "Admin",
  "PointsV2",
  "GetFilteredPointsAdditions"
];
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "after"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "filterByPointsPoolId"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "filterByUserId"
    },
    {
      "defaultValue": 20,
      "kind": "LocalArgument",
      "name": "first"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": "first",
        "cursor": "after",
        "direction": "forward",
        "path": (v0/*: any*/)
      }
    ],
    "refetch": {
      "connection": {
        "forward": {
          "count": "first",
          "cursor": "after"
        },
        "backward": null,
        "path": (v0/*: any*/)
      },
      "fragmentPathInResult": [],
      "operation": require('./PointsAdditionsTable_Refetch.graphql')
    }
  },
  "name": "PointsAdditionsTable_QueryFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "AdminQueryType",
      "kind": "LinkedField",
      "name": "Admin",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "PointsV2AdminSchema",
          "kind": "LinkedField",
          "name": "PointsV2",
          "plural": false,
          "selections": [
            {
              "alias": "GetFilteredPointsAdditions",
              "args": [
                {
                  "kind": "Variable",
                  "name": "filterByPointsPoolId",
                  "variableName": "filterByPointsPoolId"
                },
                {
                  "kind": "Variable",
                  "name": "filterByUserId",
                  "variableName": "filterByUserId"
                }
              ],
              "concreteType": "PointsAdditionsV2Connection",
              "kind": "LinkedField",
              "name": "__PointsAdditionsTable_GetFilteredPointsAdditions_connection",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "PageInfo",
                  "kind": "LinkedField",
                  "name": "pageInfo",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "endCursor",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "hasPreviousPage",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "hasNextPage",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "startCursor",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "PointsAdditionsV2Edge",
                  "kind": "LinkedField",
                  "name": "edges",
                  "plural": true,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "PointsAdditionV2",
                      "kind": "LinkedField",
                      "name": "node",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "id",
                          "storageKey": null
                        },
                        {
                          "kind": "InlineDataFragmentSpread",
                          "name": "PointsAdditionsTable_PointsAdditionFragment",
                          "selections": [
                            {
                              "args": null,
                              "kind": "FragmentSpread",
                              "name": "ContentNodeTitleColumn_PointsAdditionFragment"
                            },
                            {
                              "args": null,
                              "kind": "FragmentSpread",
                              "name": "PointsPoolColumn_PointsAdditionFragment"
                            },
                            {
                              "args": null,
                              "kind": "FragmentSpread",
                              "name": "ReceivedAtColumn_PointsAdditionFragment"
                            },
                            {
                              "args": null,
                              "kind": "FragmentSpread",
                              "name": "UserColumn_PointsAdditionFragment"
                            }
                          ],
                          "args": null,
                          "argumentDefinitions": []
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "__typename",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "cursor",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};
})();

(node as any).hash = "6814c1ac1cdf8575a3f021a02d59e3ef";

export default node;
